import { call, fork, put, take, takeEvery } from 'redux-saga/effects';
import { sesionVerify } from '../api'
import { verifyCodeActions } from './actions';
import { userActions } from '../users/actions';

export function* verifyCode({ payload }) {

    const { data, verifyId } = payload;
    yield call(sesionVerify, verifyId, data);
}

export function* watchVerifySuccess() {
    while (true) {
        yield take(verifyCodeActions.FETCH_VERIFYCODE_SUCCESS);
        yield put(userActions.resetUserError());
    }
}

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchVerifyCode() {
    yield takeEvery(verifyCodeActions.CREATE_VERIFY, verifyCode);
}

//=====================================
//  ROOT
//-------------------------------------

export const verifySagas = [
    fork(watchVerifyCode),
    fork(watchVerifySuccess)
];
